// "Etiqueta" do menu ⋮ da conversa (pedido dele, 24/09/2026: *"Como nos poderiamos permitir
// informar os mesmos dois campos sem mandar o fly?"*). E' o bloco SOBRE O CLIENTE da tela do
// fly, sozinho — a mesma peca, pra as duas telas nunca divergirem.
//
// ⚠️ Antes disto a vendedora so' etiquetava mandando fly: o painel do contato grava pelo
// `PUT /contatos/:id/etiquetas`, que e' admin/gerente ([DA-697] p.2). O bloco usa as rotas
// que quem vende alcanca.
//
// ⛔ Fechar RECOLHE o nome digitado ([DA-697] p.3) — X, Esc e o botao do rodape passam pelo
// mesmo caminho; se a gravacao falhar, a janela fica aberta com o erro na tela.
import { useRef } from 'react';
import { Modal } from '../../../components/Modal';
import { BlocoSobreCliente, type BlocoSobreClienteRef } from '../componentes/BlocoSobreCliente';
import type { Contato, Conversa } from '../lib/tipos';

interface Props {
  conversa: Conversa | null;
  onFechar: () => void;
  onContatoAtualizado: (c: Contato) => void;
}

export function ModalEtiquetaContato({ conversa, onFechar, onContatoAtualizado }: Props) {
  const blocoRef = useRef<BlocoSobreClienteRef | null>(null);
  if (!conversa) return null;
  const ct = conversa.contato;
  const nome = [ct.nome, ct.sobrenome].filter(Boolean).join(' ') || ct.push_name || ct.telefone || ct.jid;

  async function fechar() {
    if (blocoRef.current && !(await blocoRef.current.salvarNome())) return;
    onFechar();
  }

  return (
    <Modal
      aberto
      onFechar={() => void fechar()}
      titulo={`Etiqueta — ${nome}`}
      largura={640}
      // Unica saida da janela: `btn-primario`, porque o secundario sozinho some no rodape ([DA-667]).
      rodape={<button type="button" className="btn-primario" onClick={() => void fechar()}>Fechar</button>}
    >
      <BlocoSobreCliente ref={blocoRef} contatoId={ct.id} onContatoAtualizado={onContatoAtualizado} />
    </Modal>
  );
}
